<template>
  <router-link
    :to="{name: 'gvnt_info', params: {gvntId: gvntId}}"
  >{{text}}</router-link>
</template>

<script>
export default {
  name: 'GvntLink',

  props: {
    gvntId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'game event',
    }
  },

  computed: {
    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.gvntId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      } else {
        return idStr;
      }
    },
  },
};
</script>
